import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1'
import PageHeader from '../../Global/PageHService'
import Details from '../MenDetails/Details'
import Cta from '../../Global/Cta'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageHeader Title="Services Details" Subtitle="Business Intelligence" />
            <Details />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
